module.exports = __webpack_public_path__ + "img/no-contributed.23f30b7b.png";